module.exports = __webpack_public_path__ + "img/brand3.004cb471.png";